export enum PersonStatuses {
  Active = "ACTIVE",
  Unregistered = "UNREGISTERED",
  Pending = "PENDING",
  Deceased = "DECEASED",
  Inactive = "INACTIVE",
}
